import Logger from '../../Logger';
import { ChartControlsProps, ChartErrorDetails } from './ChartControlsInterface';
import { Dispatch } from 'redux';

export const storeServerData = (propKey: string, serverData: string | any) => {
  return {
    type: 'STORE_SERVER_DATA',
    payload: { propKey, serverData },
  };
};

// export const setNameWithAgg = (propKey: string,SetNameWithAgg:string) => {
// 	return {
// 	  type: "SET_NAME_WITH_AGG",
// 	  payload: {propKey,SetNameWithAgg},
// 	};
//   };

export const storeErrorDetails = (propKey: string, chartErrorDetails: ChartErrorDetails | null) => {
  return {
    type: 'STORE_CHART_ERROR_DETAILS',
    payload: { propKey, chartErrorDetails },
  };
};

export const resetExtraMeasureField = (propKey: string) => {
  return {
    type: 'RESET_EXTRA_MEASURE_FIELD',
    payload: { propKey },
  };
};

export const updateChartData = (propKey: string, chartData: string | any) => {
  return {
    type: 'UPDATE_CHART_DATA',
    payload: { propKey, chartData },
  };
};
export const updateQueryResult = (propKey: string, query: string | any) => {
  return {
    type: 'UPDATE_QUERY_DATA',
    payload: { propKey, query },
  };
};

export const setColorScheme = (propKey: string, color: string) => {
  return { type: 'CHANGE_COLOR_SCHEME', payload: { propKey, color } };
};

export const setTileThemeId = (propKey: string, themeId: string) => {
  return {
    type: 'SET_TILE_THEME_ID',
    payload: { propKey, themeId },
  };
};

export const setAreaColorOptions = (propKey: string, option: string, value: string | number) => {
  return { type: 'AREA_COLOR_OPTIONS', payload: { propKey, option, value } };
};

export const addControl = (tabId: number, nextTileId: number, newTab: boolean) => {
  if (newTab) {
    return {
      type: 'ADD_NEW_CONTROL_FROM_TAB',
      payload: { tabId, tileId: nextTileId, newTab },
    };
  } else {
    return {
      type: 'ADD_NEW_CONTROL',
      payload: {
        tabId: tabId,
        tileId: nextTileId,
      },
    };
  }
};

export const duplicateControl = (propKey: string, chartControl: ChartControlsProps) => {
  Logger('info', 'chartControl', chartControl);
  return {
    type: 'DUPLICATE_CHART_CONTROL',
    payload: { propKey, chartControl },
  };
};

export const removeChartControls = (
  tabId: number | string,
  tileId: number | string,
  propKey: string,
  tileIndex: number | string,
) => {
  return {
    type: 'DELETE_CONTROLS',
    payload: { tabId, tileId, propKey, tileIndex },
  };
};

export const removeMultipleChartControls = (tabId: number) => {
  return { type: 'DELETE_CONTROLS_OF_TAB', payload: tabId };
};

// ===================================
// Color Scale
export const setColorScaleOption = (
  option: string,
  value: string | number | boolean,
  propKey: string,
) => {
  return {
    type: 'SET_COLOR_SCALE_OPTION',
    payload: { option: option, value: value, propKey: propKey },
  };
};

export const addingNewStep = (propKey: string, index: string | number, value: number | string) => {
  return {
    type: 'ADDING_NEW_STEP',
    payload: { propKey: propKey, index: index, value: value },
  };
};

export const changingValuesofSteps = (propKey: string, value: number | string) => {
  return {
    type: 'CHANGING_VALUES_OF_STEPS',
    payload: { propKey: propKey, value: value },
  };
};

export const setManualColorGauge = (propKey: string, value: string | number | boolean) => {
  return {
    type: 'CHANGING_MANUAL_COLOR_GAUGE',
    payload: { propKey: propKey, value: value },
  };
};

export const updateGaugeManualColorWrapper = (propKey: string, option: string, value: boolean) => {
  return {
    type: 'CHANGING_MANUAL_COLOR_GAUGE',
    payload: { propKey, value },
  };
};

export const switchAutotoManualinSteps = (propKey: string, value: string | number) => {
  return {
    type: 'SWITCH_STEPS_AUTO_MANUAL',
    payload: { propKey: propKey, value: value },
  };
};
// ===================================
// Labels

export const updateCrossTabStyleOptions = (
  propKey: string,
  option: string | number,
  value: string | number | {},
) => {
  return {
    type: 'UPDATE_CROSSTAB_STYLE_OPTIONS',
    payload: { propKey: propKey, option: option, value: value },
  };
};

export const updateCrossTabHeaderLabelOptions = (
  propKey: string,
  option: string | number,
  value: string | number | string[] | boolean,
) => {
  return {
    type: 'UPDATE_CROSSTAB_HEADER_LABEL_OPTIONS',
    payload: { propKey: propKey, option: option, value: value },
  };
};

export const updateCrossTabCellLabelOptions = (
  propKey: string,
  option: string | number,
  value: string | number | boolean,
) => {
  return {
    type: 'UPDATE_CROSSTAB_CELL_LABEL_OPTIONS',
    payload: { propKey: propKey, option: option, value: value },
  };
};

export const updateLayoutOptions = (
  propKey: string,
  option: string,
  value: string | Record<string, number> | boolean,
) => {
  return {
    type: 'UPDATE_LAYOUT_OPTIONS',
    payload: { propKey: propKey, option: option, value: value },
  };
};

export const updateLabelOption = (
  propKey: string,
  option: string | number,
  value: string | number | boolean,
) => {
  return {
    type: 'UPDATE_LABEL_OPTIONS',
    payload: { propKey: propKey, option: option, value: value },
  };
};

export const updateStateLabelOption = (
  propKey: string,
  option: string | number,
  value: string | number | boolean,
) => {
  return {
    type: 'UPDATE_STATE_LABEL_OPTIONS',
    payload: { propKey: propKey, option: option, value: value },
  };
};

export const updateLabelPosition = (propKey: string, value: string | number) => {
  return {
    type: 'UPDATE_LABEL_POSITION',
    payload: { propKey: propKey, value: value },
  };
};
export const updateLabelPadding = (propKey: string, value: string | number) => {
  return {
    type: 'UPDATE_LABEL_PADDING',
    payload: { propKey: propKey, value: value },
  };
};

// ===================================
// Format

export const updateFormatOption = (
  propKey: string,
  formatType: any,
  option: string | number,
  value: string | number | boolean | string[],
  series: string = '1',
) => {
  return {
    type: 'UPDATE_FORMAT_OPTIONS',
    payload: { propKey, formatType, option, value, series },
  };
};

// ==============================
// Legend

export const updateLegendOptions = (
  propKey: string,
  option: string | number,
  value: string | number,
) => {
  return { type: 'UPDATE_LEGEND_OPTIONS', payload: { propKey, option, value } };
};

export const resetLegendOptions = (propKey: string, marginValues: any, legendValues: any) => {
  return {
    type: 'RESET_LEGEND_OPTIONS',
    payload: { propKey, marginValues, legendValues },
  };
};

// ==============================
// Margin

export const updateChartMargins = (
  propKey: string,
  option: string | number,
  value: string | number,
) => {
  return { type: 'UPDATE_CHART_MARGINS', payload: { propKey, option, value } };
};

export const setSelectedMargin = (propKey: string, margin: any) => {
  return { type: 'SELECTED_MARGIN', payload: { propKey, margin } };
};

// ==============================
// MouseOver

export const enableMouseOver = (propKey: string, enable: any) => {
  return { type: 'ENABLE_MOUSE_OVER', payload: { propKey, enable } };
};

export const enableSmoothCurve = (propKey: string, enable: any) => {
  return { type: 'ENABLE_SMOOTH_CURVE', payload: { propKey, enable } };
};

// ==============================
// Grid & Axis

export const enableGrid = (propKey: string, value: string | number, show: any) => {
  return { type: 'ENABLE_GRID', payload: { propKey, value, show } };
};

export const updateAxisMinMax = (propKey: string, axisKey: any, axisValue: any) => {
  return { type: 'AXIS_MIN_MAX', payload: { propKey, axisKey, axisValue } };
};
export const updateAxisMinMaxforScatter = (propKey: string, axisKey: any, axisValue: any) => {
  return {
    type: 'AXIS_MIN_MAX_FOR_SCATTER',
    payload: { propKey, axisKey, axisValue },
  };
};

export const loadChartControls = (chartControls: any) => {
  return { type: 'LOAD_CHART_CONTROLS', payload: chartControls };
};

// ==============================
// Reset state

export const resetChartControls = () => {
  return { type: 'RESET_CHART_CONTROLS' };
};

export const updateReverse = (propKey: string, value: boolean) => {
  return { type: 'UPDATE_REVERSE', payload: { propKey, value } };
};

export const updatePieAxisOptions = (
  propKey: string,
  option: string | number,
  value: string | number,
) => {
  return {
    type: 'UPDATE_PIE_AXIS_OPTIONS',
    payload: { propKey, option, value },
  };
};

export const updateAxisOptions = (
  propKey: string,
  axis: any,
  option: string | number,
  value: string | number | string[] | boolean,
  series: string = '1',
) => {
  return {
    type: 'UPDATE_AXIS_OPTIONS',
    payload: { propKey, axis, option, value, series },
  };
};

export const updateGaugeAxisOptions = (
  propKey: string,
  option: string | number,
  value: string | number,
) => {
  return {
    type: 'UPDATE_GAUGE_AXIS_OPTIONS',
    payload: { propKey, option, value },
  };
};

//==================== calender chart ======================================

export const updateCalendarStyleOptions = (
  propKey: string,
  option: string | number,
  value: string | number,
) => {
  return {
    type: 'UPDATE_CALENDER_STYLE_OPTIONS',
    payload: { propKey, option, value },
  };
};

export const updateBoxPlotStyleOptions = (
  propKey: string,
  option: string | number,
  value: string | number,
) => {
  return {
    type: 'UPDATE_BOXPLOT_STYLE_OPTIONS',
    payload: { propKey, option, value },
  };
};

export const updateGeoChartStyleOptions = (
  propKey: string,
  option: string | number,
  value: string | number | {},
) => {
  return {
    type: 'UPDATE_GEOCHART_STYLE_OPTIONS',
    payload: { propKey, option, value },
  };
};

export const updateTreeMapStyleOptions = (
  propKey: string,
  option: string | number,
  value: string | number,
) => {
  return {
    type: 'UPDATE_TREEMAP_STYLE_OPTIONS',
    payload: { propKey, option, value },
  };
};

export const updateSankeyStyleOptions = (
  propKey: string,
  option: string | number,
  value: string | number | boolean,
) => {
  return {
    type: 'UPDATE_SANKEY_STYLE_OPTIONS',
    payload: { propKey, option, value },
  };
};

export const updatePieChartStyleOptions = (propKey: string, option: string, value: any) => {
  return {
    type: 'UPDATE_PIE_CHART_STYLE_OPTIONS',
    payload: { propKey, option, value },
  };
};

export const updateDoughChartStyleOptions = (propKey: string, option: string, value: any) => {
  return {
    type: 'UPDATE_DOUGH_CHART_STYLE_OPTIONS',
    payload: { propKey, option, value },
  };
};
export const updateRoseChartStyleOptions = (propKey: string, option: string, value: any) => {
  return {
    type: 'UPDATE_ROSE_CHART_STYLE_OPTIONS',
    payload: { propKey, option, value },
  };
};
export const updateLineChartStyleOptions = (propKey: string, option: string, value: any) => {
  return {
    type: 'UPDATE_LINE_CHART_STYLE_OPTIONS',
    payload: { propKey, option, value },
  };
};
export const updateAreaChartStyleOptions = (propKey: string, option: string, value: any) => {
  return {
    type: 'UPDATE_AREA_CHART_STYLE_OPTIONS',
    payload: { propKey, option, value },
  };
};
export const updateStackedAreaChartStyleOptions = (propKey: string, option: string, value: any) => {
  return {
    type: 'UPDATE_STACKED_AREA_CHART_STYLE_OPTIONS',
    payload: { propKey, option, value },
  };
};
export const updateScatterChartStyleOptions = (propKey: string, option: string, value: any) => {
  return {
    type: 'UPDATE_SCATTER_CHART_STYLE_OPTIONS',
    payload: { propKey, option, value },
  };
};
export const updateFunnelChartStyleOptions = (propKey: string, option: string, value: any) => {
  return {
    type: 'UPDATE_FUNNEL_CHART_STYLE_OPTIONS',
    payload: { propKey, option, value },
  };
};
export const updateBarChartStyleOptions = (propKey: string, option: string, value: any) => {
  return {
    type: 'UPDATE_BAR_CHART_STYLE_OPTIONS',
    payload: { propKey, option, value },
  };
};
export const updateHorizontalBarChartStyleOptions = (
  propKey: string,
  option: string,
  value: any,
) => {
  return {
    type: 'UPDATE_HORIZONTAL_BAR_CHART_STYLE_OPTIONS',
    payload: { propKey, option, value },
  };
};
export const updateStackedBarChartStyleOptions = (propKey: string, option: string, value: any) => {
  return {
    type: 'UPDATE_STACKED_BAR_CHART_STYLE_OPTIONS',
    payload: { propKey, option, value },
  };
};
export const updateHorizontalStackedBarChartStyleOptions = (
  propKey: string,
  option: string,
  value: any,
) => {
  return {
    type: 'UPDATE_HORIZONTAL_STACKED_BAR_CHART_STYLE_OPTIONS',
    payload: { propKey, option, value },
  };
};

export const updateWaterfallChartStyleOptions = (propKey: string, option: string, value: any) => {
  return {
    type: 'UPDATE_WATERFALL_CHART_STYLE_OPTIONS',
    payload: { propKey, option, value },
  };
};

export const updateRichText = (propKey: string, value: string | number) => {
  return { type: 'UPDATE_RICH_TEXT', payload: { propKey, value } };
};

export const updateRichTextManualColor = (propKey: string, value: boolean) => {
  return { type: 'UPDATE_RICH_TEXT_MANUAL_COLOR', payload: { propKey, value } };
};

export const updateRichTextOnAddingDYnamicMeasure = (
  propKey: string,
  value: boolean,
  dmValue: string | number,
  style: any,
  dmId: string | number,
) => {
  return {
    type: 'UPDATE_RICH_TEXT_ON_ADDING_DYNAMIC_MEASURE',
    payload: { propKey, value, dmValue, style, dmId },
  };
};

export const updateCardControls = (propKey: string, option: string, value: any) => {
  return { type: 'UPDATE_CARD_CONTROLS', payload: { propKey, option, value } };
};

export const clearRichText = (propKey: string) => {
  return { type: 'CLEAR_RICH_TEXT', payload: { propKey } };
};
export const addTableConditionalFormats = (propKey: string, item: any) => {
  return { type: 'ADD_TABLE_CONDITIONAL_FORMATS', payload: { propKey, item } };
};
export const deleteTablecf = (propKey: string, index: number) => {
  return {
    type: 'DELETE_TABLE_CONDITIONAL_FORMATS',
    payload: { propKey, index },
  };
};
export const updatecfObjectOptions = (propKey: string, index: number, item: any) => {
  return { type: 'UPDATE_CF_OBJECT1', payload: { propKey, index, item } };
};

export const updateConditionalFormatName = (propKey: string, name: string, index: number) => {
  return { type: 'UPDATE_CONDITIONAL_FORMAT_NAME', payload: { propKey, name, index } };
};

export const updateRuleObjectOptions = (
  propKey: string,
  objectIndex: number,
  itemIndex: number,
  item: any,
) => {
  return {
    type: 'UPDATE_RULE_OBJECT',
    payload: { propKey, objectIndex, itemIndex, item },
  };
};

//new code
export const addTableLabel = (propKey: string, item: any) => {
  return { type: 'ADD_TABLE_CONDITIONAL_FORMATS', payload: { propKey, item } };
};

export const updatecfObjectOptions1 = (propKey: string, item: any) => {
  return { type: 'UPDATE_CF_OBJECT', payload: { propKey, item } };
};

export const addOrEditSimplecardConditionalFormat = (propKey: string, item: any) => {
  return { type: 'ADD_OR_EDIT_SIMPLECARD_CF', payload: { propKey, item } };
};

export const SortChartData = (propKey: string, chartData: string | any) => {
  return {
    type: 'SORT_CHART_DATAS',
    payload: { propKey, chartData },
  };
};

export const SortOrder = (propKey: string, order: string) => {
  return {
    type: 'SORT_ORDER',
    payload: { propKey, order },
  };
};

export const SortedValue = (propKey: string, value: string | any) => {
  return {
    type: 'SORTED_VALUE',
    payload: { propKey, value },
  };
};

export const MeasureValue = (propKey: string, value: string | any) => {
  return {
    type: 'MEASURE_VALUE',
    payload: { propKey, value },
  };
};

export const showHideFilter = (propKey: string, isShow: boolean) => {
  return {
    type: 'SHOW_HIDE_FILTER',
    payload: { propKey, isShow },
  };
};

export const Showhide = (propKey: string, value: string | any) => {
  return {
    type: 'SHOW_HIDE',
    payload: { propKey, value },
  };
};

export const setCurrentOperator = (propKey: string, currentOperator: string) => {
  return {
    type: 'UPDATE_CURRENT_OPERATOR',
    payload: { propKey, currentOperator },
  };
};

export const setCurrentOperatorColumn = (propKey: string, currentOperator: string) => {
  return {
    type: 'UPDATE_CURRENT_OPERATOR_COLUMN',
    payload: { propKey, currentOperator },
  };
};

export const updateRichTextDynamicValue = (propKey: string, value: string | number) => {
  return {
    type: 'UPDATE_RICH_TEXT_DYNAMIC_VALUE',
    payload: { propKey, value },
  };
};

//showHideOptions

export const setShowHideOperatorValue = (propKey: string, value: string) => {
  return {
    type: 'UPDATE_SHOW_HIDE_OPERATOR_VALUE',
    payload: { propKey, value },
  };
};

export const setShowHideNumberInputValue = (
  propKey: string,
  value: number | string,
  dataType: string,
) => {
  return {
    type: 'UPDATE_SHOW_HIDE_NUMBER_INPUT_VALUE',
    payload: { propKey, value, dataType },
  };
};

export const setShowHideFuncNum = (propKey: string, value: string) => {
  return {
    type: 'UPDATE_FUNC_NUM',
    payload: { propKey, value },
  };
};

export const setShowNumAction = (propKey: string, value: boolean) => {
  return {
    type: 'SET_SHOW_NUM',
    payload: { propKey, value },
  };
};

export const callQueryAPI = (propKey: string, callQueryAPI: boolean) => {
  return {
    type: 'CALL_QUERY_API',
    payload: { propKey, callQueryAPI },
  };
};

//Total for waterfall Chart
export const enableDisableTotalChartControlSwitch = (propKey: string, isEnable: boolean) => {
  return {
    type: 'ENABLE_DISABLE_TOTAL_SWITCH',
    payload: { propKey, isEnable },
  };
};

export const changeTotalBarPosition = (propKey: string, isRight: boolean) => {
  return {
    type: 'CHANGE_TOTAL_BAR_POSITION',
    payload: { propKey, isRight },
  };
};

export const renameGrandTotal = (propKey: string, newName: string) => {
  return {
    type: 'RENAME_GRAND_TOTAL',
    payload: { propKey, newName },
  };
};

export const updateRowSecurityFilters = (
  propKey: string,
  filteredData: any,
  currentOperator: 'user' | 'group',
) => {
  return {
    type: 'UPDATE_ROW_SECURITY_FILTERS',
    payload: {
      propKey,
      operator: currentOperator.toLowerCase(),
      filterData: filteredData,
    },
  };
};

export const updateUserSelection = (
  propKey: string,
  currentOperator: 'user' | 'group',
  email: any,
) => {
  return {
    type: 'UPDATE_USER_SELECTION',
    payload: {
      propKey,
      operator: currentOperator.toLowerCase(),
      email,
    },
  };
};

export const removeRowSecurityCard = (
  propKey: string,
  id: any,
  currentOperator: 'user' | 'group',
) => {
  return {
    type: 'REMOVE_ROW_SECURITY_CARD',
    payload: {
      propKey,
      operator: currentOperator.toLowerCase(),
      id,
    },
  };
};

export const removeRowSecurityFilter = (propKey: string) => {
  return {
    type: 'REMOVE_ROW_SECURITY_FILTERS',
    payload: {
      propKey,
    },
  };
};

export const updateColumnSecurityFilters = (
  propKey: string,
  filteredData: any,
  currentOperator: 'user' | 'group',
) => {
  return {
    type: 'UPDATE_COLUMN_SECURITY_FILTERS',
    payload: {
      propKey,
      operator: currentOperator.toLowerCase(),
      filterData: filteredData,
    },
  };
};

export const updateMeasureDropFilters = (
  propKey: string,
  filteredData: any,
  currentOperator: 'user' | 'group',
) => {
  return {
    type: 'UPDATE_MEASURE_DROP_FILTERS',
    payload: {
      propKey,
      operator: currentOperator.toLowerCase(),
      filterData: filteredData,
    },
  };
};

export const updateMeasureMappingColumn = (
  propKey: string,
  currentOperator: 'user' | 'group',
  mapping: any,
) => {
  return {
    type: 'UPDATE_MEASURE_MAPPING_COLUMN',
    payload: {
      propKey,
      operator: currentOperator.toLowerCase(),
      mapping,
    },
  };
};

export const updateUserSelectionColumn = (
  propKey: string,
  currentOperator: 'user' | 'group',
  email: any,
) => {
  return {
    type: 'UPDATE_USER_SELECTION_COLUMN',
    payload: {
      propKey,
      operator: currentOperator.toLowerCase(),
      email,
    },
  };
};

export const removeColumnSecurityCard = (
  propKey: string,
  id: any,
  currentOperator: 'user' | 'group',
) => {
  return {
    type: 'REMOVE_COLUMN_SECURITY_CARD',
    payload: {
      propKey,
      operator: currentOperator.toLowerCase(),
      id,
    },
  };
};

export const removeMeasureFieldCard = (
  propKey: string,
  id: any,
  currentOperator: 'user' | 'group',
) => {
  return {
    type: 'REMOVE_MEASURE_FIELD_CARD',
    payload: {
      propKey,
      operator: currentOperator.toLowerCase(),
      id,
    },
  };
};

export const removeMeasureMappingColumn = (
  propKey: string,
  currentOperator: 'user' | 'group',
  id: any,
) => {
  return {
    type: 'REMOVE_MEASURE_MAPPING_COLUMN',
    payload: {
      propKey,
      operator: currentOperator.toLowerCase(),
      id,
    },
  };
};

export const removeColumnSecurityFilter = (propKey: string) => {
  return {
    type: 'REMOVE_COLUMN_SECURITY_FILTERS',
    payload: {
      propKey,
    },
  };
};

export const initializeWaterfallState = (propKey: string) => {
  return {
    type: 'INITIALIZE_WATERFALL_STATE',
    payload: { propKey },
  };
};

// date format
export const initializeDateFormatState = (propKey: string) => {
  return {
    type: 'INITIALIZE_DATE_FORMAT_STATE',
    payload: { propKey },
  };
};

//tooltip format
export const enableDisableTooltipChartControlSwitch = (propKey: string, isEnable: boolean) => {
  return {
    type: 'ENABLE_DISABLE_TOOLTIP_SWITCH',
    payload: { propKey, isEnable },
  };
};

export const initializeTooltipFormatState = (propKey: string) => {
  return {
    type: 'INITIALIZE_TOOLTIP_FORMAT_STATE',
    payload: { propKey },
  };
};

export const changeGeoMapUnMatched = (propKey: string, value: string[]) => {
  return {
    type: 'CHANGE_GEOMAP_UNMATCHED',
    payload: {
      propKey,
      value,
    },
  };
};

export const SetModifyOptions = (
  propKey: string,
  modifiedBy:
    | 'filter'
    | 'filter_override_open'
    | 'filter_override_close'
    | 'axis'
    | 'filter_group'
    | null,
  lastModifiedFilter: string | null,
) => {
  return {
    type: 'SET_MODIFY_OPTIONS',
    payload: {
      propKey,
      modifiedBy,
      lastModifiedFilter,
    },
  };
};

// ==============================Tooltip New functionalities(window fn, override & rename) ==========//

//----updates a extra measure field ----//
export const updateExtraMeasureField = (
  propKey: string,
  binIndex: number,
  itemIndex: number,
  item: any,
  triggerDataFetch: boolean = true,
) => {
  return (dispatch: Dispatch<any>) => {
    dispatch({
      type: 'UPDATE_EXTRA_MEASURE_FIELD',
      payload: { propKey, binIndex, itemIndex, item },
    });
    //---- Trigger axes edited to fetch new data ----//
    if (triggerDataFetch) {
      dispatch({ type: 'TOGGLE_AXES_EDITED', payload: { propKey, axesEdited: true } });
    }
  };
};

export const enableOverrideForExtraMeasure = (propKey: string, uId: string) => {
  return {
    type: 'ENABLE_OVERRIDE_FOR_EXTRA_MEASURE',
    payload: { propKey, uId },
  };
};

//for word Cloud chart

export const updateWordCloudOptions = (propKey: string, option: string, value: any) => {
  return {
    type: 'UPDATE_WORD_CLOUD_OPTIONS',
    payload: { propKey, option, value },
  };
};

export const toggleMeasureAsLine = (propKey: string, measureUidList: string[]) => {
  return {
    type: 'TOGGLE_MEASURE_AS_LINE',
    payload: { propKey, measureUidList },
  };
};

export const toggleMeasureAsBar = (propKey: string, measureUidList: string[]) => {
  return {
    type: 'TOGGLE_MEASURE_AS_BAR',
    payload: { propKey, measureUidList },
  };
};

//-------multiple series -----//
export const updateSeriesInAxisOptions = (
  propKey: string,
  seriesName: string,
  operation: 'add' | 'remove',
  axisType: string,
) => {
  return {
    type: 'UPDATE_SERIES',
    payload: { propKey, seriesName, operation, axisType },
  };
};

//-------------new sort configuration ---------//

export const addSortConfiguration = (propKey: string, sortConfig: any) => {
  return {
    type: 'ADD_SORT_CONFIGURATION',
    payload: { propKey, sortConfig },
  };
};

export const updateSortConfiguration = (propKey: string, index: number, sortConfig: any) => {
  return {
    type: 'UPDATE_SORT_CONFIGURATION',
    payload: { propKey, index, sortConfig },
  };
};

export const deleteSortConfiguration = (propKey: string, index: number) => {
  return {
    type: 'DELETE_SORT_CONFIGURATION',
    payload: { propKey, index },
  };
};

export const initializeGaugeChartFormats = (propKey: string) => {
  return {
    type: 'INITIALIZE_GAUGE_CHART_FORMATS',
    payload: { propKey },
  };
};
